import React, {useState} from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import SlidingPane from 'react-sliding-pane'
import {SendGridWebHookViewerProps} from "./types";
import {ICONS} from "../common";
import {WebHookService} from "../../services";
import Moment from "react-moment";


export const SendGridWebHookViewer = ({
  email
}:SendGridWebHookViewerProps) => {
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const [changeLog, setChangeLog] = useState([])

  return (
    <>
        <span className="ml-3 d-print-none">
        <ReactBootstrap.Button
          variant={"dark"}
          size={"sm"}
          onClick={(e) => {
               e.stopPropagation();  //  <-
              setIsPaneOpen(true)
          }}
        >
            {ICONS.LOG} Email Log
        </ReactBootstrap.Button>
            </span>


      <SlidingPane
        overlayClassName="on-top"
        width={"50vw"}
        isOpen={isPaneOpen}
        title={"Email Event log"}
        onAfterOpen={() => {
            new WebHookService().makeGetRequest({email:email}).then((response) => {
                setChangeLog(response)
            }).catch((error) => {
                console.log(error)
            })

        }}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >

              <ReactBootstrap.Table striped bordered hover>
                   <tbody>
                   <tr>
                          <th>Event Type</th>
                       {/*<th>Category</th>*/}
                       {/*<th>Reason</th>*/}
                       {/*<th>Status</th>*/}
                       <th>TimeStamp</th>
                   </tr>
                   {changeLog?.results?.map((log, index) => {
                            return (

                                    <tr key={index}>
                                        <td>{log.event_type}</td>
                                        {/*<td>{log.category}</td>*/}
                                        {/* <td>{log.reason}</td>*/}
                                        {/*<td>{log.status}</td>*/}

                                        <td> <Moment format="DD-MM-YYYY hh:mm A" local>
        {log.timestamp}
      </Moment></td>



                                    </tr>

                            )
                        })}

                     </tbody>
              </ReactBootstrap.Table>


      </SlidingPane>
    </>
  )
}
